import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServiceService } from '../_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mentor-dashboard',
  templateUrl: './mentor-dashboard.component.html',
  styleUrls: ['./mentor-dashboard.component.scss']
})
export class MentorDashboardComponent implements OnInit {
  userForm: any = JSON.parse(localStorage.getItem('login_user_details'));
  spinner: boolean;
  sidebarVisible: boolean = true;
  showCourse : boolean = false;
  showFeedBack : boolean = false;
 constructor(private router:Router,private ApiService: ApiServiceService,private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.handleBackButtonForModal();

    //$.widget.bridge('uibutton', $.ui.button);
  }
  handleBackButtonForModal() {
    // Push initial state to history
    history.pushState(null, '', window.location.href);
  
    window.onpopstate = () => {
      const modal = document.querySelector('.modal.show') as HTMLElement;
      if (modal) {
        // Find the close button inside the modal and trigger a click event on it
        const closeButton = modal.querySelector('.close') as HTMLElement;
        if (closeButton) {
          closeButton.click();
        }
  
        // Prevent default back navigation
        history.pushState(null, '', window.location.href);
      } else {
        // Allow back navigation as usual if modal is not open
        this.router.navigate(['previous-page']); // Replace 'previous-page' with the actual route you want to navigate to
      }
    };
  }

  ngOnDestroy(): void {
    // Cleanup event listener to avoid memory leaks
    window.onpopstate = null;
  }
  
  toggle:any=false;
  menuitem:any=false;


  clickEvent(event:any){
    //if you just want to toggle the class; change toggle variable.
    this.toggle = !this.toggle;       
 }
 hideSidebar() {
  this.sidebarVisible = false;  
}
showSidebar() {
  this.sidebarVisible = true;  
}
//   async signout(){
  
//   localStorage.removeItem('user_district');
//   localStorage.removeItem('user_constituency');
//   localStorage.removeItem('login_user_details');
//   sessionStorage.removeItem('validUserToken');
//   this.router.navigate(['']);
//   await window.location.reload();
   
//  }


async signout() {
  Swal.fire({
    title: 'Are you sure you want to sign out?',
    text: 'This will log you out of the system.',
    icon: 'warning',
    iconColor:'#015792',
    showCancelButton: true,
    confirmButtonColor: '#015792',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, sign out!',
    cancelButtonText: 'Cancel'
  }).then(async (result) => {
    if (result.isConfirmed) {
      // Remove items from local storage
      localStorage.removeItem('user_district');
      localStorage.removeItem('user_constituency');
      localStorage.removeItem('login_user_details');
      sessionStorage.removeItem('validUserToken');
     sessionStorage.clear();
      // Navigate to the login page and reload the window
      this.router.navigate(['login']).then(() => {
        window.location.reload();
      });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      // Reload the page without removing local storage
      window.location.reload();
    }
  });
}

 mentorDeleted() {
  Swal.fire({
    title: "Are you sure?",
    text: "This action will close the mentor account permanently!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, close it!",
    cancelButtonText: "No, keep it",
    confirmButtonColor: " #e5183b", // Set the confirm button color here
    cancelButtonColor: "#015792", // Set the cancel button color here
  }).then((result) => {
    if (result.isConfirmed) {
      console.log(this.userForm.id);
      this.spinner = true;
      this.spinnerService.show();

      this.ApiService.deletedMenter(this.userForm.id).subscribe(
        (data: any) => {
          console.log("Mentor deleted successfully:", data);
          this.spinner = false;
          this.spinnerService.hide();
    
          this.router.navigate(['']);
        
          // Optionally, perform any additional actions after deletion
        },
        (error: any) => {
          console.error("Error deleting mentor:", error);
        }
      );
    }
  });
}
footerdate=new Date().getFullYear();

show(){
  this.showCourse = !this.showCourse;
}

showFeedback(){
 this.showFeedBack = !this.showFeedBack;
}


}
